// removed by extract-text-webpack-plugin
module.exports = {"Filters":"kHvGpWNd","SelectLabel":"_12dMHPKe","Select":"_2cidbg-y","Lecture":"_30TWPdpv","Card":"_156MdPPi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/lectures/lectures-page.styles.scss
// module id = 280
// module chunks = 0